/**
 * BizPulseAI · i18n bootstrap
 *
 * Uses i18next + react-i18next. English is the only fully populated locale
 * today — all other languages listed in `src/lib/languages.js` are declared
 * as supported languages so the switcher can offer them, but they fall back
 * to English via `fallbackLng` until their JSON resource file is added
 * under `src/i18n/locales/<code>.json`.
 *
 * Adding a new language later is a two-step change:
 *   1. Create `src/i18n/locales/<code>.json` with the same keys.
 *   2. Import + register it in the `resources` map below.
 * No component code needs to change.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";

export const LS_KEY = "bp_language";

// Register available resource bundles. New languages plug in here.
const resources = {
  en: { translation: en },
};

const stored =
  typeof window !== "undefined" ? window.localStorage?.getItem(LS_KEY) : null;

i18n.use(initReactI18next).init({
  resources,
  lng: stored || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
